import { createEnum } from './createEnum';

export const NotificationTypeEnum = createEnum({
    AnnouncementCreatedNotification: {
        id: 'AnnouncementCreatedNotification',
        name: 'AnnouncementCreatedNotification',
    },
    ArticleCreatedNotification: {
        id: 'ArticleCreatedNotification',
        name: 'ArticleCreatedNotification',
    },
    BookCreatedNotification: {
        id: 'BookCreatedNotification',
        name: 'BookCreatedNotification',
    },
    CommentNotification: {
        id: 'CommentNotification',
        name: 'CommentNotification',
    },
    DocumentNotification: {
        id: 'DocumentNotification',
        name: 'DocumentNotification',
    },
    EducationLessonCreatedNotification: {
        id: 'EducationLessonCreatedNotification',
        name: 'EducationLessonCreatedNotification',
    },
    EducationLessonRecentNotification: {
        id: 'EducationLessonRecentNotification',
        name: 'EducationLessonRecentNotification',
    },
    EssentialNotification: {
        id: 'EssentialNotification',
        name: 'EssentialNotification',
    },
    GalleryCreatedNotification: {
        id: 'GalleryCreatedNotification',
        name: 'GalleryCreatedNotification',
    },
    NewsCreatedNotification: {
        id: 'NewsCreatedNotification',
        name: 'NewsCreatedNotification',
    },
    SurveyCreatedNotification: {
        id: 'SurveyCreatedNotification',
        name: 'SurveyCreatedNotification',
    },
    UsersBirthdaysNotification: {
        id: 'UsersBirthdaysNotification',
        name: 'UsersBirthdaysNotification',
    },
    VacancyCreatedNotification: {
        id: 'VacancyCreatedNotification',
        name: 'VacancyCreatedNotification',
    },
    TaskTrackerCommentCreated: {
        id: 'TaskTrackerCommentCreated',
        name: 'TaskTrackerCommentCreated',
    },
    TaskTrackerTaskAlmostExpired: {
        id: 'TaskTrackerTaskAlmostExpired',
        name: 'TaskTrackerTaskAlmostExpired',
    },
    TaskTrackerTaskCreated: {
        id: 'TaskTrackerTaskCreated',
        name: 'TaskTrackerTaskCreated',
    },
    TaskTrackerTaskDone: {
        id: 'TaskTrackerTaskDone',
        name: 'TaskTrackerTaskDone',
    },
    TaskTrackerTaskExpired: {
        id: 'TaskTrackerTaskExpired',
        name: 'TaskTrackerTaskExpired',
    },
    TaskTrackerTaskExpiredAtProposeOwner: {
        id: 'TaskTrackerTaskExpiredAtProposeOwner',
        name: 'TaskTrackerTaskExpiredAtProposeOwner',
    },
    TaskTrackerTaskExpiredAtProposeUser: {
        id: 'TaskTrackerTaskExpiredAtProposeUser',
        name: 'TaskTrackerTaskExpiredAtProposeUser',
    },
    TaskTrackerTaskExpiredAtProposeDenied: {
        id: 'TaskTrackerTaskExpiredAtProposeDenied',
        name: 'TaskTrackerTaskExpiredAtProposeDenied',
    },
    TaskTrackerTaskExpiredAtProposeAccepted: {
        id: 'TaskTrackerTaskExpiredAtProposeAccepted',
        name: 'TaskTrackerTaskExpiredAtProposeAccepted',
    },
    TaskTrackerTaskExpiredAtUpdated: {
        id: 'TaskTrackerTaskExpiredAtUpdated',
        name: 'TaskTrackerTaskExpiredAtUpdated',
    }
} as const, {
    id: null,
    name: 'Неопредлённая',
});

